import { Flex, ModuleLayout, Spacing } from '@billy/design-system'
import Cookies from 'js-cookie'
import { useCallback } from 'react'
import { useParams } from 'react-router'

import { BankIntegrationContextProvider } from '@features/openBanking/contexts/bankIntegrationContext'
import { BankConnectionStatusActions } from '@features/openBanking/elements/BankConnectionStatusActions'
import { ExternalInvoiceReconciliationSuggestion } from '@features/reconciliation/elements/ExternalInvoiceReconciliationSuggestion'
import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { TransactionViewTrackingContext } from '@features/transactions/enums/transactionViewTrackingContext'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { CookieKeys } from '../../../../enums/cookieKeys'
import { useSegment } from '../../../../hooks'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { InvoiceViewUrlParams } from '../../types/invoiceViewUrlParams'
import { InvoiceContextProvider } from './contexts/invoiceContext'
import { ExternalInvoicePaymentPane } from './elements/InvoicePaymentPane/ExternalInvoicePaymentPane'
import { InvoicePreview } from './elements/InvoicePreview'
import { InvoiceTitle } from './elements/InvoiceTitle'
import { InvoiceViewActions } from './elements/InvoiceViewActions'
import { RegisterPaymentModal } from './elements/InvoiceViewActions/elements/RegisterPaymentModal'
import { InvoiceViewSidebar } from './elements/InvoiceViewSidebar'

export const InvoiceView = () => {
  const { track } = useSegment()
  const { invoiceDocumentType, invoiceDocumentId } = useParams<InvoiceViewUrlParams>()
  const { url: invoicesUrl } = useOrganizationViewUrl(reactRoute.organization.invoices.getMainRoute())
  const { organization } = useUserOrganization()

  const storedInvoicesListQuery = Cookies.get(CookieKeys.InvoicingInvoicesListQuery) || ''

  const handleBackButtonClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoice View - Back arrow button clicked', { documentType: invoiceDocumentType })
  }, [invoiceDocumentType, track])

  if (!invoiceDocumentType || !invoiceDocumentId) {
    return null
  }

  return (
    <InvoiceContextProvider documentType={invoiceDocumentType} invoiceId={invoiceDocumentId}>
      <BankIntegrationContextProvider organizationId={organization?.id as string}>
        <ModuleLayout
          backButtonTo={invoicesUrl && `${invoicesUrl}${storedInvoicesListQuery}`}
          onBackButtonClick={handleBackButtonClick}
          sideActions={<InvoiceViewActions />}
          title={<InvoiceTitle />}
          withBackButton
        >
          <BankConnectionStatusActions />

          <Flex justifyContent="center">
            <Flex flexDirection="column" gap={Spacing.S24} width="fit-content">
              <Flex flexDirection="column">
                <ExternalInvoiceReconciliationSuggestion />
                <ExternalInvoicePaymentPane />
              </Flex>
              <Flex gap={Spacing.S24} justifyContent="center" width="fit-content">
                <InvoicePreview />
                <Flex.Item>
                  <TransactionViewProvider trackingContext={TransactionViewTrackingContext.Invoice}>
                    <InvoiceViewSidebar />
                  </TransactionViewProvider>
                </Flex.Item>
              </Flex>
            </Flex>
          </Flex>
        </ModuleLayout>
        <RegisterPaymentModal />
      </BankIntegrationContextProvider>
    </InvoiceContextProvider>
  )
}
